import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0e4cb26e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0e4cb26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4cb26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4cb26e')) {
      api.createRecord('0e4cb26e', component.options)
    } else {
      api.reload('0e4cb26e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0e4cb26e&scoped=true&", function () {
      api.rerender('0e4cb26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sDLVHJ3qLb8p/JS/comp/PopupBox.vue"
export default component.exports